module.exports = __webpack_public_path__ + "static/media/dizzy.8f9cdc1e.svg";